// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmationPopup_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.ConfirmationPopup_content {
    background: white;
    border-radius: 12px;
    padding: 24px;
    min-width: 320px;
    max-width: 450px;
    width: 90%;
    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);
}

.ConfirmationPopup_message {
    font-size: 16px;
    color: #212633;
    margin-bottom: 24px;
    line-height: 1.5;
    font-family: 'Open Sans', sans-serif;
}

.ConfirmationPopup_actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.ConfirmationPopup_cancel {
    background-color: #F9F9F9;
    color: #49454F;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
    font-family: 'Open Sans', sans-serif;
}

.ConfirmationPopup_cancel:hover {
    background-color: #EFEFEF;
}

.ConfirmationPopup_confirm {
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
    color: white;
    font-family: 'Open Sans', sans-serif;
}

.ConfirmationPopup_confirm--primary {
    background-color: #FFA825;
}

.ConfirmationPopup_confirm--primary:hover {
    background-color: #E69720;
}

.ConfirmationPopup_confirm--danger {
    background-color: #E23424;
}

.ConfirmationPopup_confirm--danger:hover {
    background-color: #C42E20;
}
`, "",{"version":3,"sources":["webpack://./src/components/confirmationPopup/ConfirmationPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".ConfirmationPopup_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n}\n\n.ConfirmationPopup_content {\n    background: white;\n    border-radius: 12px;\n    padding: 24px;\n    min-width: 320px;\n    max-width: 450px;\n    width: 90%;\n    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.ConfirmationPopup_message {\n    font-size: 16px;\n    color: #212633;\n    margin-bottom: 24px;\n    line-height: 1.5;\n    font-family: 'Open Sans', sans-serif;\n}\n\n.ConfirmationPopup_actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n}\n\n.ConfirmationPopup_cancel {\n    background-color: #F9F9F9;\n    color: #49454F;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s;\n    font-family: 'Open Sans', sans-serif;\n}\n\n.ConfirmationPopup_cancel:hover {\n    background-color: #EFEFEF;\n}\n\n.ConfirmationPopup_confirm {\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s;\n    color: white;\n    font-family: 'Open Sans', sans-serif;\n}\n\n.ConfirmationPopup_confirm--primary {\n    background-color: #FFA825;\n}\n\n.ConfirmationPopup_confirm--primary:hover {\n    background-color: #E69720;\n}\n\n.ConfirmationPopup_confirm--danger {\n    background-color: #E23424;\n}\n\n.ConfirmationPopup_confirm--danger:hover {\n    background-color: #C42E20;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
